import { injectable, Inject } from 'inversify-props';
import CityList from 'app/shared/models/city-list.model';
import CurrencyList from 'app/shared/models/currency-list.model';
import SearchBody from 'app/shared/models/search-body.model';
import HttpClient from './http-client';
import moment from 'moment';


@injectable()
export class SearchService {
    @Inject() httpClient: HttpClient;
    constructor() {
    }

    public getCityList(queryValue: string): Promise<CityList> {
        return this.httpClient.post(`/location/search`, { query: queryValue });
    }

    public search(body: SearchBody) {

        const filteredBody = (JSON.parse(JSON.stringify(body)));
        filteredBody.filters = this.mapFiltersToStringBooleans(filteredBody.filters);
        filteredBody.itinerary = this.mapDatesToMSIAPI(filteredBody.itinerary);

        return this.httpClient.post('/flights/search', filteredBody);
    }

    private mapFiltersToStringBooleans(filters: any) {
        filters.cluster = filters.cluster ? '1' : '0';
        filters.hub = filters.hub ? '1' : '0';
        filters.round_trip = filters.round_trip ? '1' : '0';
        filters.airport_change = filters.airport_change ? '1' : '0';
        filters.flexible_dates = filters.flexible_dates ? '1' : '0';
        filters.include_nearby = filters.include_nearby ? '1' : '0';
        return filters;
    }

    private mapDatesToMSIAPI(itinerary: Array<any>) {
        for (let i in itinerary) {
            if (itinerary[i].departure_date && parseInt(i) < itinerary.length) {
                itinerary[i].departure_date = moment(itinerary[i].departure_date, 'DD-MMM-YYYY').format('MM/DD/YYYY');
            }
        }
        return itinerary;
    }

    public estimateSearch(body: SearchBody) {
        return this.httpClient.postTp('/estimate/get', body);
    }

    public getSolutions(body: any) {
        return this.httpClient.post('/flights/solutions', body);
    }

    public getFlightsResults(body: any) {
        return this.httpClient.post('/flights/results', body);
    }

    public getMoreOptions(body: any) {
        return this.httpClient.post('/flights/more_options', body);
    }

    public addSaveTrip(body: any) {
        return this.httpClient.post('/favorites/add', body);
    }

    public async getCurrency(): Promise<CurrencyList> {
        return this.httpClient.get('/currency');
    }

    public async getResult(url: string) {
        return this.httpClient.get(url);
    }

    public swapPkg(body: any){
        return this.httpClient.post('/flights/swappkg', body);
    }

}
